import { useMemo } from 'react';
import { Paragraph } from 'theme-ui';
import { useProductByHandle } from '@backpackjs/storefront';

import { Link, Picture } from '@snippets';

import { themed } from './CollectionCategoriesMobile.theme';

export const CollectionCategoriesItem = themed(
  ({ item, collectionHandle, theme }) => {
    const productHandle = item.mobileImage?.product?.handle;
    const manualSrc = item.mobileImage?.image?.src;

    const { product } = useProductByHandle({
      handle: productHandle,
    });

    const firstImage = useMemo(() => {
      return product?.media?.find((item) => {
        return item.mediaContentType === 'IMAGE';
      })?.image;
    }, [product?.id]);

    const isActive = useMemo(
      () => item.link?.url?.split('/').pop() === collectionHandle,
      [item.link?.url, collectionHandle]
    );

    return (
      <Link
        data-comp={CollectionCategoriesItem.displayName}
        href={item.link?.url}
        newTab={item.link?.newTab}
        sx={theme.itemLink}
      >
        <Picture
          alt={item.link?.text}
          images={[
            {
              src: firstImage?.originalSrc,
              width: 200,
              ratio: 1,
            },
          ]}
          imageSx={{
            p: manualSrc ? 0 : 7,
            objectFit: manualSrc ? 'cover' : 'contain',
          }}
          sx={{ ...theme.picture }}
        />

        <Paragraph
          sx={{
            ...theme.itemTitle,
            textDecoration: isActive ? 'underline' : 'unset',
          }}
        >
          {item.link?.text}
        </Paragraph>
      </Link>
    );
  }
);

CollectionCategoriesItem.displayName = 'CollectionCategoriesItem';
